import React from "react";
import { Space } from "antd";
import { remove as removeAccents } from "remove-accents";
import { debounce } from "lodash";
import {
  SearchToolbar,
  ServiceCategoriesDropdown
} from "../../../../../components/shared";

export function FilterControls({ onChange }) {
  const handleOnSearchChange = debounce(text => {
    const stringValue = removeAccents(text).toLowerCase();
    const value = stringValue || undefined;
    onChange && onChange({ searchString: value });
  }, 500);

  const handleOnFilterChange = (filter = {}) => {
    onChange && onChange(filter);
  };

  return (
    <Space>
      <ServiceCategoriesDropdown
        onChange={val => handleOnFilterChange({ category: val})} />
      <SearchToolbar
        onSearchChange={e => handleOnSearchChange(e.target.value)} />
    </Space>
  );
}
